import script from "./ChartWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./ChartWrapper.vue?vue&type=script&setup=true&lang=js"

import "./ChartWrapper.vue?vue&type=style&index=0&id=1ac8dd91&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ac8dd91"]])

export default __exports__